import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCircleCheck, faCirclePause, faPlus, faStore } from '@fortawesome/free-solid-svg-icons';

import UpperLoader from '../../components/Loader/UpperLoader';
import { InfoCuentasContext } from '../../Hooks/InfoCuentasContext';
import './Tiendas.css';

const Tiendas = () => {
  const { tiendas, cargando } = useContext(InfoCuentasContext);

  if (cargando) return <UpperLoader />;

  if (tiendas.length === 0) {
    return (
      <section className="mis-tiendas-vacio">
        <span className="mis-tiendas-kicker">Tus tiendas</span>
        <h3>Todavía no tenés ninguna tienda</h3>
        <p>Creá una tienda para cargar datos comerciales y empezar a publicar productos.</p>
        <Link className="mis-tiendas-cta" to="/cuenta#crear-tienda">
          <FontAwesomeIcon icon={faPlus} />
          Crear tienda
        </Link>
      </section>
    );
  }

  const activas = tiendas.filter((tienda) => tienda.habilitada !== false).length;

  return (
    <section className="mis-tiendas">
      <header className="mis-tiendas-header">
        <div>
          <span className="mis-tiendas-kicker">Tus tiendas</span>
          <h3>{tiendas.length === 1 ? 'Tu tienda' : `Tus ${tiendas.length} tiendas`}</h3>
        </div>
        <Link className="mis-tiendas-cta" to="/cuenta#crear-tienda">
          <FontAwesomeIcon icon={faPlus} />
          Crear otra
        </Link>
      </header>

      <div className="mis-tiendas-stats">
        <div>
          <span>Total</span>
          <strong>{tiendas.length}</strong>
        </div>
        <div>
          <span>Activas</span>
          <strong>{activas}</strong>
        </div>
        <div>
          <span>Destacadas</span>
          <strong>{tiendas.filter((tienda) => tienda.destacada).length}</strong>
        </div>
      </div>

      <div className="mis-tiendas-lista">
        {tiendas.map((tienda) => {
          const activa = tienda.habilitada !== false;
          const estado = !activa ? 'Deshabilitada' : tienda.destacada ? 'Destacada' : 'Activa';

          return (
            <article key={tienda.idtienda} className="mis-tiendas-item">
              <div className="mis-tiendas-icon">
                <FontAwesomeIcon icon={faStore} />
              </div>

              <div className="mis-tiendas-item-datos">
                <strong>{tienda.nombre}</strong>
                <span className="mis-tiendas-meta">
                  <FontAwesomeIcon icon={activa ? faCircleCheck : faCirclePause} />
                  {estado}
                  {tienda.vencimiento && ` · vence el ${tienda.vencimiento}`}
                </span>
              </div>

              <div className="mis-tiendas-actions">
                <Link className="mis-tiendas-secondary" to="/cuenta#crear-aviso">Publicar</Link>
                <Link className="mis-tiendas-ver" to={`/tienda/${tienda.idtienda}`}>
                  Ver tienda <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Tiendas;
